import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ZapIcon from '@zapsa/zap-icons';

import PriceCalculator from 'modules/PriceCalculator';

class OffersView extends Component {
static propTypes = {
  setModal: PropTypes.func.isRequired,
}

constructor(props) {
  super(props);
  this.state = {};
}

render() {
  const { setModal } = this.props;
  return (
    <div
      id="offers"
      style={{
        width: '100vw',
        overflow: 'hidden',

        background: '#F6F6F6',
      }}
    >
      <div className="container">
        <div className="container-title">{this.props.translations['offers.ourOffers']}</div>
        <div className="offers-container u-pt-4">
          <div className="offer">
          <div className="perks-container">
              <div
                style={{
                  textAlign: 'left',
                }}
              >
                <div>
                <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.GDPR']}
                </div>
                <div>
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.hostedInLuxembourg']}
                </div>
                <div>
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.applicationsAvalaible']}
                </div>
                <div>
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.multipleLicenceTypes']}
                </div>
                <div data-tip data-for="data-tooltip">
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.unlimitedStorage']}
                </div>
                <div>
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.customisation']}
                </div>
                <div>
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.frequentUpdates']}
                </div>
                <div>
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.userAndAdminSupport']}
                </div>
                <div>
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.vaultEndToEnd']}
                </div>
                <div>
                  <ZapIcon icon="check-2--solid" className="u-mr-2" />
                  {this.props.translations['offers.customFeatures']}
                </div>
              </div>
            </div>
            <div
              onClick={() => {
                setModal({ visible: true,
                  closeName: this.props.translations['utils.close'],
                  content: () => (
                    <div>
                      <div className="alert alert--info-accent u-mt-2">
                        {this.props.translations['pricing.fullPricingDesc'](() => {
                          this.props.setModal({ visible: false });
                          window.fcWidget.open();
                        })}
                      </div>
                    </div>
                  ),
                  modalClass: 'modal--extra-large' });
              }}
              className="download-button u-mt-2"
              role="presentation"
            >{this.props.translations['menu.pricing']}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
}

export default OffersView;
